<template>
    <x-data-table
        class="no-row-hover"
        :headers="headers"
        :items="formattedAuditList"
        hide-actions
    >
        <template v-slot:no-data>
            <p class="error-message text-xs-center">No history found</p>
        </template>

        <template v-slot:items="props">
            <td>
                <span v-if="isOriginalDeclarationAudit(props.item)"> - </span>
                <span v-else>
                    {{ props.item.effective_date | formatDate }}
                - {{ getNextEndorsementEffectiveDate(props.item) }}
                </span>
            </td>

            <td>
                {{ getAuditOrigin(props.item) | capitalize }}
            </td>

            <td>
                <p v-for="(value, key) in props.item.old_values">
                    <span v-if="key === 'information_sections'">Additional information updated</span>
                    <template v-else>
                        <span v-for="val in formatAuditData(key,value)">
                            {{ val.text | capitalize }}: {{ val.value }}<br>
                        </span>
                    </template>
                </p>
            </td>

            <td>
                <p v-for="(value, key) in getAuditNewValues(props.item)">
                    <span v-if="key === 'information_sections'">Additional information updated</span>
                    <template v-else>
                        <span v-for="val in formatAuditData(key,value)">
                            {{ val.text | capitalize }}: {{ val.value }}<br>
                        </span>
                    </template>
                </p>
            </td>

            <td>
                <x-btn
                    v-if="props.item.document"
                    color="tertiary"
                    class="square-icon extra-small"
                    @click="downloadVersionDocument(props.item.document.id)"
                >
                    <i class="material-icons">browser_updated</i>
                </x-btn>
            </td>

        </template>
    </x-data-table>
</template>

<script>
    import formatDate from "../../../filters/FormatDate";
    import productConfig from '~/mixins/productConfig';

    export default {
        name: 'VersionHistoryTable',
        props: ['risk', 'audits', 'productConfigKey', 'userType', 'currencyCode'],
        mixins: [productConfig,],
        data() {
            return {
                currencies: [],
                countries: [],
                sectors: [],
                headers: [
                    {
                        text: 'Date',
                        value: 'created_at'
                    },
                    {
                        text: 'Type of change',
                        value: 'origin'
                    },
                    {
                        text: 'Old values',
                        sortable: false
                    },
                    {
                        text: 'New values',
                        sortable: false
                    },
                    {
                        text: 'Download',
                        sortable: false
                    }
                ]
            }
        },
        computed: {
            formattedAuditList() {
                if (!(this.currencies.length > 0 && this.countries.length > 0 && this.sectors.length > 0)) {
                    return [];
                }
                return this.audits;
            }


        },
        mounted () {
            this.fetchData();
        },
        methods: {
            async fetchData() {
                this.currencies = (await axios.get(this.$root.api('currency'))).data.data;
                this.countries = this.$root.countries;
                this.sectors = (await axios.get(this.$root.api('sectors'))).data.data;

            },
            getCountryName(id) {
                if (id) {
                    return this.countries.find(country => country.id === id).name
                }
                return '';
            },
            getCurrencyCode(id) {
                if (id) {
                    return this.currencies.find(currency => id === currency.id).code;
                }
                return this.currencyCode;
            },
            formatKey(key) {
                if (this.productHasProperty(key)) {
                    return this.getPropertyLabel(key);
                }

                return key.replace(/_/g, ' ');
            },
            async downloadVersionDocument(documentId) {
                window.location.href = (await axios.get(`/api/${this.userType}/documents/${documentId}`)).data.url;
            },
            getNextEndorsementEffectiveDate(audit) {
                const filteredAudits = this.audits.filter(audit => audit.origin === 'Endorsement');
                const sortedAudits  = filteredAudits.sort((a, b) => this.$moment(a.created_at).format('YYYYMMDD') - this.$moment(b.created_at).format('YYYYMMDD'));

                for (let i = 0; i < sortedAudits.length; i++) {
                    if (sortedAudits[i].id === audit.id && i !== (sortedAudits.length - 1)) {
                        return formatDate(sortedAudits[i + 1].effective_date);
                    }
                }
                return 'present';
            },
            getAuditOrigin(audit) {
                if (this.isOriginalDeclarationAudit(audit)) {
                    return 'Declaration';
                }

                return audit.origin;
            },
            getAuditNewValues(audit) {
                if (this.isOriginalDeclarationAudit(audit)) {
                    return [];
                }

                return audit.new_values;
            },
            isOriginalDeclarationAudit(audit) {
                return audit.event === 'created' && audit.auditable_type === 'App\\Broker\\Models\\Declaration'
            },
            formatAuditData(property, value) {
                const self = this;
                let dataAry = [];
                let val = null;
                let text = null;
                text =  this.formatKey(property);

                if (property === 'currency_id') {
                    val = self.getCurrencyCode(value);
                    text = 'Currency';
                } else if (property === 'country_id') {
                    val = self.getCountryName(value);
                    text = 'Country';
                } else if (property === 'waiting_period') {
                    val = self.$options.filters.yearsAndDays(value);
                } else if (property === 'contract_value') {
                    val = self.applyFormatFilter(value, 'currency', self.getCurrencyCode());
                } else if (property === 'current_contract_value' || property === 'limit_of_liability') {
                    val = self.applyFormatFilter(value, 'currency', self.getCurrencyCode());
                } else if (property === 'indemnity') {
                    val = self.applyFormatFilter(value, 'percent');
                } else if (property === 'inception_date' || property === 'expiry_date' || property === 'settlement_due_date' || property === 'off_risk_at') {
                    val = self.$options.filters.formatDate(value);
                } else if (property === 'sub_sector_id') {
                    self.sectors.forEach(function (sector) {
                        sector.sub_sector.forEach(function (subSector) {
                            if (subSector.id === value) {
                                text = 'Sub sector';
                                val = subSector.name;
                                dataAry.push(
                                    {
                                        text:'Sector',
                                        value:sector.name
                                    }
                                );
                            }
                        });
                    });
                } else if (property === 'obligors' || property === 'guarantors') {
                    return;
                } else {
                    val = value;
                }
                dataAry.push(
                    {
                        text:text,
                        value:val
                    }
                );
                return dataAry;
            },
            applyFormatFilter(value, format, addValue = '') {
                switch (format) {
                    case 'currency':
                        return this.$options.filters.currency(value, addValue);
                    case 'days':
                    case 'risk_period':
                        return this.$options.filters.yearsAndDays(value);
                    case 'percent':
                        return this.$options.filters.percent(value);
                    case 'yes_no':
                    case 'boolean':
                        return value ? 'Yes' : 'No';
                    case 'decimal':
                        return value ? Number.parseFloat(value).toFixed(addValue ? addValue : 2) : ''
                    default:
                        return value || '';
                }
            },
        }
    }
</script>

<style lang="scss" scoped>
    .x-table.x-datatable tbody tr {
        td:first-child,
        td:not(:first-child) {
            padding: 6px 12px;
        }
    }
</style>
